<template>
  <a
    :id="`footnote-reference-${targetId}`"
    v-smooth-scroll
    :href="`#footnote-target-${targetId}`"
    class="footnote-reference footnote-anchor"
    @click.prevent="clickHandler"
    ><span class="a-visually-hidden"
      ><a-label path="footnote.to-target" :is-visible="true"></a-label> </span
    >[{{ targetId }}]</a
  >
</template>

<script>
export default {
  props: {
    targetId: {
      type: String,
      required: true,
    },
  },
  mounted() {
    const hash = window.location.hash;
    if (!!hash.match(/#footnote-target-/g)) {
      this.emit();
      setTimeout(() => {
        document.querySelector(`${hash}`).focus();
      }, 0);
    }
  },
  methods: {
    clickHandler() {
      this.emit();
      this.setFocus();
    },
    emit() {
      this.$root.$emit('footnote');
    },
    setFocus() {
      this.$nextTick(() => {
        document.querySelector(`#footnote-target-${this.targetId}`).focus();
      });
    },
  },
};
</script>
